export default __webpack_public_path__ + "static/media/hunnyplay-banner.8d226491.gif";